import * as ACTION_TYPES from "../actions/actionTypes";
import dotProp from "dot-prop-immutable";

const INITIAL_STATE = {
  reservations: [],
  calendar: {
    start: "",
    end: "",
    dates: []
  },
  reservation: {},
  reservationSchedule: [
    // Sample
    // {
    //   resId: { resNum: "230" },
    //   date: "2019-06-24",
    //   schedule_json: {
    //     isOpenDropdown: false,
    //     score: 110,
    //     visits: [
    //       { name: "IH", time: "09:00", score: 40 },
    //       { name: "MARJ", time: "09:00", score: 20 },
    //       { name: "IH", time: "09:00", score: 40 },
    //       { name: "MR", time: "09:00", score: 10 }
    //     ]
    //   }
    // }
  ],
  zoom: 12,
  savedResSchCount: 0,
  savingReservationSchedule: false,

  reservationRooms: [],
  roomModalReservationId: null,
  isRoomModalOpen: false,
  isRoomSaving: false,
  isRoomLoading: false,
  isOldDaysEnabled: false,
  isMemberModalOpen: false,
  reservationIndex: null,
  isBulkOpen: false,
  isDeleteReservationModalOpen: false,
  deleteReservationIndex: null,
  fromDate: null,
  toDate: null,
  isBulkApplying: false
};

export default (state = INITIAL_STATE, action) => {
  const { UPDATE_RESERVATION_PROPS, MERGE_RESERVATION_PROPS, DELETE_RESERVATION_PROPS, CLEAR_STATE } = ACTION_TYPES;
  switch (action.type) {
    case UPDATE_RESERVATION_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.set(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case MERGE_RESERVATION_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.merge(newState, action.payload[i].prop, action.payload[i].value);
      }
      return newState;
    }
    case DELETE_RESERVATION_PROPS: {
      let newState = state;
      for (let i = 0; i < action.payload.length; i++) {
        newState = dotProp.delete(newState, action.payload[i].prop);
      }
      return newState;
    }
    case CLEAR_STATE: {
      let newState = state;
      newState = INITIAL_STATE;
      return newState;
    }
    default:
      return state;
  }
};
